export interface Lagerplatz {
  barcode: string,
  bezeichnung: string,
  gesperrt: string,
  id: number,
  kommplatz: string,
  lager: string,
  lagerbereich: string,
  lagerplatz: string,
  name1: string,
  stellplaetze: any,
  typ: string
}
